/**
 * 指定文字列の先頭または末尾にある以下の文字を削除します（複数あっても）。
 *
 * * 半角スペース
 * * 全角スペース
 *
 * @param {String} value トリム対象文字列
 */
export function trimAll(value) {
  // eslint-disable-next-line no-irregular-whitespace
  return value.replace(/^[\s|　]+|[\s|　]+$/g, '')
}
